import { useEffect, useRef } from "react";



export function Privacy() {
    const focusRef = useRef(null);

    useEffect(() => {
        focusRef.current?.focus();
    }, []);


    return (
        <div className="bg-gray-100 text-gray-900 min-h-screen">
            <div ref={focusRef} tabIndex={0} className="sr-only">Start of [Page Name] Page</div>
            {/* Header Section */}
            <header className="rounded bg-indigo-800 py-6">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl font-bold text-white">Privacy Policy</h1>
                    <p className="mt-2 text-lg text-indigo-50">SendFalcon Self-Hosted Email Service</p>
                </div>
            </header>

            {/* Main Content */}
            <main className="container mx-auto px-4 py-12">
                {/* Introduction Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Introduction</h2>
                    <p className="text-gray-700 leading-relaxed">
                        At SendFalcon, we prioritize your privacy. As a self-hosted email service, SendFalcon empowers businesses to manage their email communications on their own infrastructure, ensuring maximum control over data privacy. This Privacy Policy outlines how data is handled when you use SendFalcon and your responsibilities as a user managing your own instance.
                    </p>
                </section>

                {/* Data Collection Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Data Collection</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Self-Hosted Data</h3>
                            <p className="text-indigo-100">
                                Since SendFalcon is self-hosted, all email data, user information, and related content are stored on your own servers. SendFalcon does not collect or store any personal data on our behalf.
                            </p>
                        </div>
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Support Interactions</h3>
                            <p className="text-indigo-100">
                                If you contact our support team, we may collect limited information, such as your contact details, to assist you. This information is used solely for support purposes and is not shared.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Data Security Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Data Security</h2>
                    <p className="text-gray-700 leading-relaxed">
                        As a self-hosted service, you are responsible for securing your SendFalcon instance. We provide end-to-end encryption for email communications, but you must ensure your server infrastructure is protected against unauthorized access and complies with applicable data protection laws.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 mt-4">
                        <li>Implement strong server security measures.</li>
                        <li>Regularly update SendFalcon software to maintain security patches.</li>
                        <li>Comply with local and international data protection regulations.</li>
                    </ul>
                </section>

                {/* Third-Party Sharing Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Third-Party Sharing</h2>
                    <p className="text-gray-700 leading-relaxed">
                        SendFalcon does not share any data with third parties, as all data is stored on your infrastructure. You are responsible for any third-party integrations you choose to implement with your SendFalcon instance.
                    </p>
                </section>

                {/* Changes to Policy Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Changes to Privacy Policy</h2>
                    <p className="text-gray-700 leading-relaxed">
                        We may update this Privacy Policy from time to time. Any changes will be posted on this page, and it is your responsibility to review them periodically. Continued use of SendFalcon after changes constitutes acceptance of the updated policy.
                    </p>
                </section>
            </main>
        </div>
    );
};